import { required } from "@corporate-tailwind/corp-form";
import { OrderHistoryDto } from "./order-history.model";
import { OrderDto, OrderSchema } from "./order.model";
import { PickupPointDto, PickupPointSchema } from "./pickup-point.model";
import { CustomerDto, CustomerSchema } from "./customer.model";

export class OrderTrackingDto {
    order: OrderDto | null = null;
    customer: CustomerDto | null = null;
    pickupPoint: PickupPointDto |null = null;
    history: OrderHistoryDto[] | null = null
}

export class OrderTrackingForSchema extends OrderTrackingDto {
    static schema = {
        order:          { type: OrderSchema, builderOption: required },
        customer:       { type: CustomerSchema, builderOption: required },
        pickupPoint:    { type: PickupPointSchema, builderOption: required },
        history:        { type: OrderHistoryDto, builderOption: required }
    };
}